export const configurations = {
    configurations: [],
    configurationDetail: undefined,
    configurationAuditHistory: {
        content: [],
        pageable: {
            pageNumber: 0,
            pageSize: 20,
            offset: 0,
            sort: {
                sorted: false,
                unsorted: true,
                empty: true
            },
            paged: true,
            unpaged: false
        },
        totalPages: 0,
        totalElements: 0,
        last: true,
        size: 20,
        number: 0,
        sort: {
            sorted: false,
            unsorted: true,
            empty: true
        },
        first: true,
        numberOfElements: 0,
        empty: true
    },
    isDrawerOpen: false,
    isDrawerContentOpen: false
};
